import { Link } from 'react-router-dom'
import { isNativeApp } from '../lib/native'

const SUPPORT_EMAIL = 'yangtianxiong1991@gmail.com'

/** Support page: how to use the app, what it needs, and how to reach us. */
export default function Support() {
  return (
    <main className={`landing${isNativeApp ? ' landing-app' : ''} prose`}>
      <header className="landing-head">
        <div>
          <h1>Support</h1>
          <p className="muted">Mala Racing</p>
        </div>
        <Link className="button secondary small-button" to="/">
          ← Home
        </Link>
      </header>

      <h2>Getting started</h2>
      <ol>
        <li>Open Race Studio from the home page.</li>
        <li>Tap "Open local .xrk files" and pick session files exported from Race Studio 3, or try the sample session.</li>
        <li>Tick laps in "Sessions &amp; laps" to compare them. Hover or tap a chart or the track map to read every lap at the same spot.</li>
      </ol>

      <h2>Downloading from a Solo 2 (iOS app)</h2>
      <ol>
        <li>Power the Solo 2 on and join its Wi-Fi network in the iPhone Settings. The network is named after the logger.</li>
        <li>In Race Studio, open the sidebar and tap "Connect to Solo 2".</li>
        <li>Tick sessions and tap "Download to your phone". Back on the internet, use "Upload to my repo" to keep them in your account.</li>
      </ol>
      <p className="muted small">
        iOS asks once for Local Network access. If a connection fails, the error shown includes the last protocol steps; send it to us and we
        will have a look.
      </p>

      <h2>Accounts</h2>
      <p>
        An account is optional. It gives you a private repo for your sessions so you can open them on any device. You can delete the account
        and everything in it from <Link to="/account">My Account</Link>.
      </p>

      <h2>Contact</h2>
      <p>
        Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>. Please include the app version and, for connection problems, the
        error text.
      </p>

      <p className="muted small">
        <Link to="/">Home</Link> · <Link to="/privacy">Privacy policy</Link>
      </p>
    </main>
  )
}
